import React from 'react';
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import th from '../../assets/img/Payment Information-rafiki.png';
import { message } from "antd";
import MiCompAPI from "../../util/api";

import {

  Row,
  Col
} from 'antd';
import { useLocation,useHistory } from 'react-router-dom';


const SubscriptionPaypal = (props) => {
  const api = new MiCompAPI(props.userPermandMasters);
  const location = useLocation();
  const navigate = useHistory();

  let { price ,subscription_Type,days} = location.state;
  const createOrder = (data, actions) => {
    return actions.order
      .create({
        purchase_units: [
          {
            description: "Registration",
            amount: {
              currency_code: "USD",
              value: parseFloat(price) ,
            },
          },
        ],
      })
      .then((orderID) => {
        return orderID;
      });
  };

  const onApprove = (data, actions) => {
    return actions.order.capture().then(function (details) {
      api.invoke(
        "SaveUserSubscription" ,
        "post",
        (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              navigate.push('/subscription');
              message.destroy();
              message.success(data.statusMessage, 3).then(() => window.location.reload());
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          }
        }, {subscription:subscription_Type,days:days,paypal:details}
      );
    });
  };

  return (<div className="mi_main" >
    <Row>
      <Col md={12} xs={0}  >
        <img className='ant-login-image' alt="example" style={{ width: '450px', margin: '0', height: 450 }} src={th} />

      </Col>
      <Col md={12} xs={24} >
        <PayPalScriptProvider
          options={{
            "client-id":
              "AU47C1ye3EoHsb5ksQmoXWzftsHAUbqOp6CxD1T-63v9WIdVqFuKTTxL_sq8I31VAxgrtG6ETArDnQ6i",
          }}
        >

          <div>

            <PayPalButtons
              style={{ layout: "vertical" }}
              createOrder={createOrder}
              // onError={onError}
              onApprove={onApprove}
            />

          </div>
        </PayPalScriptProvider>
      </Col>
    </Row>
  </div>)


}
export default SubscriptionPaypal;
